import React from "react";


export const ReturnPolicy = () => {
  return (
    <div className="privacy-policy-content u-maxWidth600">
      <h1>Piroshky Baking Company Website Refund Policy</h1>
      <h2>1. Problems or Quality Issues must be reported before 4 PM (PST) on the seventh day after receiving your order:</h2>
        <p>
            a. Problems or Quality issues reported after 4 PM (PST) seven (7) days or more after receiving your order are not eligible for a refund.
        </p>
        <p>
            b. Examples of a Problem or Quality Issue include (but are not limited to): missing or incorrect items, defective or damaged items, etc.
        </p>
      <h2>2. Refunds may be issued to the original form of payment for the following circumstances:</h2>
        <p>
            a. Incorrect items were received.
        </p>
        <p>
            b. Items were omitted from the order.
        </p>
        <p>
            c. Items arrived in damaged condition.
        </p>
      <h2>3. In the case that an event or delivery must be postponed or rescheduled:</h2>
        <p>
            a. If the rescheduled event or delivery prevents you from picking up or receiving your order, a refund in the form of a gift card may be issued.
        </p>
        <p>
            b. Please be aware that, barring unforeseen and unpredictable circumstances beyond our control, it is Piroshky Piroshky’s policy to adhere to all scheduled event dates and times.
        </p>
      <h2>4. Order Cancellation Policy:</h2>
        <p>
            a. Orders may not be cancelled or refunded less than five (5) days prior to the event or delivery day.
        </p>
        <p>
            b. Orders that are cancelled between five (5) and nine (9) days prior to the event or delivery day may be refunded in the form of a gift card.
        </p>
        <p>
            c. Orders that are cancelled ten (10) or more days prior to the event or delivery day may be rescheduled for a future event or delivery day. Alternatively, a refund may be issued to the original form of payment
        </p>
      <h2>5. Refunds are not available for the following circumstances:</h2>
        <p>
            a. The customer did not claim their order during the scheduled event pickup timeframe.
        </p>

        <p>
            b. The customer provided incorrect contact information, resulting in the inability to accurately fulfill the order.
        </p>
        <p>
            c. Problems or Quality Issues with order are reported more than seven (7) days after receiving the order (Section 1 above)
        </p>
        <p>
            d. Product quality issues related to Section 6 below.
        </p>
      <h2>6. The customer is responsible for maintaining the product quality after the order has been delivered or received:</h2>
        <p>
            a. Due to the perishable nature of our products and the limited life of the ice packs included, it is the customer’s responsibility to reheat and consume the products promptly or freeze them promptly upon delivery or receipt of the order.
        </p>
        <p>
            b. Piroshky Piroshky does not guarantee quality of products that have been left unattended or at ambient temperatures for an extended period of time after delivery or receipt of the order.
        </p>
        <p>
            c. Piroshky Piroshky does not guarantee quality of products that are not reheated or frozen according to the instructions provided with each order <a style={{color:"blue"}} href="https://piroshkybakery.com/static/img/menuV2.pdf">(these may also be found on our website).</a>
        </p>
    </div>
  )
};
